import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks, profileData } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
        isScrolled || menuOpen ? 'bg-cream/95 backdrop-blur-sm border-b border-ink/15' : 'bg-transparent'
      }`}
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-3.5">
        <nav className="flex items-center justify-between gap-4">
          <button
            onClick={() => scrollToSection('#home')}
            className="text-base font-bold text-ink tracking-tight hover:opacity-70 transition-opacity"
          >
            {profileData.name.split(' ')[0]}
            <span className="text-flag">.</span>
          </button>

          <div className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-[11px] font-bold uppercase tracking-label text-subtle hover:text-ink transition-colors"
              >
                {link.name}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
          <a
            href={`mailto:${profileData.email}`}
            className="shrink-0 inline-block px-3.5 py-1.5 bg-ink text-cream text-xs font-semibold rounded-md border-[1.5px] border-ink hover:bg-cream hover:text-ink transition-colors"
          >
            Email me
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((o) => !o)}
            className="lg:hidden p-1.5 -mr-1.5 text-ink hover:opacity-70 transition-opacity"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="mobile-nav"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
          </div>
        </nav>

        {menuOpen && (
          <div id="mobile-nav" className="lg:hidden mt-3 pb-2 border-t border-ink/15 pt-2">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="block w-full text-left py-2.5 text-xs font-bold uppercase tracking-label text-ink-soft hover:text-ink transition-colors"
              >
                {link.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
